import { useEffect, useState } from "react";

/**
 * Returns true only once `active` has stayed true continuously for `delayMs`.
 * Resets to false immediately when `active` goes false. Use to suppress loading
 * UI for fast operations (so quick fetches never flash a skeleton) while still
 * surfacing it for genuinely slow ones.
 */
export function useDelayedFlag(active: boolean, delayMs = 500): boolean {
    const [shown, setShown] = useState(false);
    useEffect(() => {
        if (!active) {
            setShown(false);
            return;
        }
        const timer = setTimeout(() => setShown(true), delayMs);
        return () => clearTimeout(timer);
    }, [active, delayMs]);
    return shown;
}
